/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEntityTechOrderBy = {
    Asset: 'asset',
    SourceAsset: 'source_asset',
    Port: 'port',
    TechName: 'tech_name',
    Shared: 'shared',
    Found: 'found',
    Created: 'created',
    Updated: 'updated',
    Version: 'version'
} as const;
export type ControlEntityTechOrderBy = typeof ControlEntityTechOrderBy[keyof typeof ControlEntityTechOrderBy];


export function ControlEntityTechOrderByFromJSON(json: any): ControlEntityTechOrderBy {
    return ControlEntityTechOrderByFromJSONTyped(json, false);
}

export function ControlEntityTechOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityTechOrderBy {
    return json as ControlEntityTechOrderBy;
}

export function ControlEntityTechOrderByToJSON(value?: ControlEntityTechOrderBy | null): any {
    return value as any;
}

